document.addEventListener('DOMContentLoaded', function() {

	var button = document.getElementById('mobile-nav-toggle');
	var menu = document.querySelector('.navline');

	if (!button || !menu) {
		return;
	}

	button.addEventListener('click', function(e) {

		e.preventDefault();

		menu.classList.toggle('mobile-open');

	});

});